/* @flow */
import * as React from 'react';
import styles from './styles.module.scss';

export type Props = {
  isVisible?: boolean,
  size?: number | string,
  type?: 'default' | 'pulse',
};

const Spinner = (props: Props): React$Element<any> => {
  const { isVisible = true, size = 25, type = 'default' } = props;
  const style = { width: size, height: size };
  return isVisible ? <div className={styles[type]} style={style} /> : <div style={style} />;
};

export default Spinner;
